/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Concerned ownership information for a building - represents ownership relationships that affect or relate to the building
 */
export interface BuildingConcernedOwnershipDto { 
    /**
     * Building identifier (BUD_ID)
     */
    budId?: number;
    /**
     * Cadastral area code where the ownership is registered
     */
    katuzeKod?: number;
    /**
     * Land registry folio number (list vlastnictví)
     */
    lv?: number;
    /**
     * Subject ownership identifier (OPSUB_ID)
     */
    opsubId?: number;
    /**
     * Ownership share as formatted text (e.g., \'1/2\', \'1/1\')
     */
    share?: string;
    /**
     * Denominator of the ownership share fraction
     */
    shareDenominator?: number;
    /**
     * Numerator of the ownership share fraction
     */
    shareNumerator?: number;
    /**
     * Name of the subject (owner or right holder)
     */
    subjectName?: string;
    /**
     * Ownership right type code (TYPRAV_KOD) - e.g., ownership, lien, easement
     */
    typravKod?: string;
}

